import React from 'react';
import styles from './SummaryComponent.module.css';
import '../styles/theme.css';

function SummaryComponent() {
  return (
    <section className={styles['summary']}>
      <div className={styles['summary-inner']}>
        <div className={styles['quote-glyph']} aria-hidden="true">“</div>
        <div className={styles['summary-stack']}>
          <div className={styles['eyebrow']}>Our Approach</div>
          <div className={styles['rule']} aria-hidden="true" />
          <h2 className={styles['summary-text']}>
            We combine <em>academic rigour</em>, practical expertise, and strategic
            vision<br />to craft transformative solutions to research and policy
            challenges.
          </h2>
        </div>
      </div>
    </section>
  );
}

export default SummaryComponent;
